import { render, staticRenderFns } from "./NewVerifyDelivery.vue?vue&type=template&id=0e5f15e5&scoped=true"
import script from "./NewVerifyDelivery.vue?vue&type=script&lang=js"
export * from "./NewVerifyDelivery.vue?vue&type=script&lang=js"
import style0 from "./NewVerifyDelivery.vue?vue&type=style&index=0&id=0e5f15e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5f15e5",
  null
  
)

export default component.exports